import { Grid, Paper, Skeleton, Typography, Stack, Box, useMediaQuery, useTheme  } from '@mui/material';
import { Fragment, default as React, useContext, useEffect, useReducer, useRef, useState, useCallback, useMemo } from 'react';
import { useLocation, useSearchParams } from "react-router-dom";
import RoleContext from '../../auth/RoleContext.js';
import { ROLES } from '../../auth/role.js';
import Cache from '../../cache/Cache.js';
import FeatureFlagsContext from '../../config/FeatureFlagsContext.js';
import TabPanel from '../../form/TabPanel.js';
import Page from '../../layout/Page.js';
import EventBus from '../../utils/EventBus.js';
import Event from '../../utils/EventNames.js';
import AddEditArticleDialog from '../ArticleComponents/AddEditArticleDialog.js';
import ArticlesCommandBar from '../ArticleComponents/ArticlesCommandBar.js';
import ShareArticleDialog from '../ArticleComponents/ShareArticleDialog.js';
import SharePreviewDialog from '../ArticleComponents/SharePreviewDialog.js';
import MediumArticleList from '../ArticleComponents/MediumArticleList.js';
import SmallArticleList from '../ArticleComponents/SmallArticleList.js';
import CommunityEventNames from '../EventNames.js';
import CategoriesListControls from '../ResourceLibrary/ResourceList/CategoriesListControls.js';
import { AppliedFilters, TAG_QUERY_PARAM } from '../Tags.js';
import { getArticlesByTags, listArticles } from '../data/index.js';
import { getSiteSettings } from '../data/documents.js';
import ArticleCategory from './ArticleCategory.js';
import { getSiteConfig } from '../../community/siteProvider.js';

const TabbedViews = {
  PUBLISHED: 'published',
  UNPUBLISHED: 'unpublished'
}

const initialState = {

  unpublished: {
    // <Category>: {
    //   loading: false,
    //   loadingMore: false,
    //   articles: undefined,
    //   totalAvailable: undefined,
    //   totalLoaded: 0,
    //   nextToken: undefined,
    // },
  },

  published: {
    // <Category>: {
    //   loading: false,
    //   loadingMore: false,
    //   articles: undefined,
    //   totalAvailable: undefined,
    //   totalLoaded: 0,
    //   nextToken: undefined,
    // },
  }

}

function articleReducer(state, action) {
  if(action === 'reset') return initialState
  const [currentView, category, key, value] = action
  const _state = structuredClone(state)
  _state[currentView][category] = _state[currentView][category] || {}
  _state[currentView][category][key] = value
  return _state
}


function InnerOUCornerPage(props = {resetPage: undefined, siteConfig: undefined}) {
  const roleDetails = useContext(RoleContext)
  const ff = useContext(FeatureFlagsContext)
  
  const theme = useTheme();
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));
  const isLg = useMediaQuery(theme.breakpoints.up('lg'));
  const isMd = useMediaQuery(theme.breakpoints.up('md'));
  const isSm = useMediaQuery(theme.breakpoints.up('sm'));

  const tilesPerRow = isXl ? 4 : isLg ? 3 : isMd ? 2 : 1

  const editableRoles = props.siteConfig ? props.siteConfig.managerRoles : []

  const canEdit = roleDetails.hasRole([...editableRoles, ROLES.ADMIN])

  const [articlesMap, dispatchArticles] = useReducer(articleReducer, initialState)
  const articlesMapRef = useRef(articlesMap)
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    articlesMapRef.current = articlesMap
  }, [articlesMap])

  const [isLoading, setIsLoading] = useState(false)
  const [loadingArticles, setLoadingArticles] = useState(true)
  const [categories, setCategories] = useState([])
  const [sortAscending, setSortAscending] = useState(true)
  const [categoryFilterApplied, setCategoryFilterApplied] = useState(false)

  const [currentView, setCurrentView] = useState(TabbedViews.PUBLISHED)

  const setCategoryExpand = () => {}
  
  const [viewCategories, setViewCategories] = useState(null)

  const filter = searchParams.get(TAG_QUERY_PARAM)

  const Heading = (props = {}) => {
    return <Grid container gap={0}>
      <Grid item xs={8}>
        <Typography variant='h6'>{props.title}</Typography>
      </Grid>
    </Grid>
  }

  const ArticlesSkeletons = () => {
    return <div style={{ display: 'flex', gap: '8px' }} className='fit-height'>
      {[1, 2, 3].map(i => <Skeleton className='fit-height' sx={{ flexGrow: 1 }} key={`skel${i}`} />)}
    </div>
  }

  const CategoryHeaderSkeleton = (props = {}) => {
    return <Skeleton sx={{
      width: '200px',
      padding: '0px',
      height: '28px',
      marginTop: '4px',
      marginBottom: props.marginBottom
    }} />
  }
  const CategorySkeleton = ({ header = true }) => {
    return <>
      {header && <Grid item xs={12}>
        <CategoryHeaderSkeleton />
      </Grid>}
      <Grid item xs={12} sx={{
        height: '200px',
        marginTop: '4px'
      }}>
        <ArticlesSkeletons />
      </Grid>
    </>
  }

  const published = currentView === TabbedViews.PUBLISHED
 
  const loadArticlesForCategory = useCallback(async (forceReset = false, category, limit) => {
    if(forceReset) setLoadingArticles(true)
    else dispatchArticles([currentView, category, 'loadingMore', true])

    const {articles, nextToken} = articlesMapRef.current?.[currentView]?.[category] || {}

    const tags = searchParams?.get(TAG_QUERY_PARAM)?.split(',');
    const offset = forceReset ? 0 : articles?.length || 0
    const visibility = { ouCorner: true, ouCornerCategory: category, highlighted: category === 'Highlighted' }

    const update = (articlesResponse) => {
      const { articles: _articles, totalSize, nextLink, totalLoaded } = articlesResponse
      if(_articles) {
        const prevArticles = forceReset ? [] : [...(articles || [])]
        const newArticles = [...prevArticles, ..._articles]
        dispatchArticles([currentView, category, 'articles', newArticles])
        dispatchArticles([currentView, category, 'totalAvailable', totalSize])
        dispatchArticles([currentView, category, 'nextToken', nextLink])
        if(totalLoaded) dispatchArticles([currentView, category, 'totalLoaded', totalLoaded])
      } 

      dispatchArticles([currentView, category, 'loading', false])
    }

    if(tags?.length) {
      for await (const articlesResponse of getArticlesByTags({visibility, tags, startIndex: offset, limit, nextToken})) {
        update(articlesResponse)
      }
    } else {
      for await (const articlesResponse of listArticles(
        visibility,
        published,
        offset,
        nextToken,
        limit)) {
        update(articlesResponse)
      }
    }

    dispatchArticles([currentView, category, 'loadingMore', false])
    setLoadingArticles(false)
  }, [currentView, dispatchArticles, published, searchParams])

  const LoadingPlaceholder = () => {
    return <Grid item xs={12}>
      <CategorySkeleton />
      <CategoryHeaderSkeleton marginBottom='4px' />
      <SmallArticleList
        articles={[]}
        loading
      />
    </Grid>
  }

  const filterCategories = useCallback((selection) => {
    if (selection.join('') === 'all' || !selection?.length) {
      setCategoryFilterApplied(false)
      setViewCategories([...categories])
    } else {
      setCategoryFilterApplied(true)
      setViewCategories(selection)
    }
  }, [categories])
  
  const OUCornerArticles = <Grid direction="row-reverse" container gap={0} sx={{ padding: '8px' }} >
    <Stack
      direction="row"
      alignItems="center"
      sx={{ width: '100%' }}
    >
      {filter && (
        <AppliedFilters
          clickable
          sx={{ paddingLeft: '4px' }}
        />
      )}

      <Box sx={{ marginLeft: 'auto' }}>
        <CategoriesListControls
          setCategoryExpand={setCategoryExpand}
          sortCategories={setSortAscending}
          categories={categories}
          filterCategories={filterCategories}
          viewCategories={viewCategories}
          includeCollapse={false}
          filteredCount={categoryFilterApplied ? viewCategories.length : 0}
        />
      </Box>
    </Stack>
    {loadingArticles && <LoadingPlaceholder />}

    {!loadingArticles && !Object.keys(articlesMap[currentView] || {}).length && <MediumArticleList
      editable={canEdit}
      maxWidth='33%'
      articles={[]}
      layout='horizontal'
      ouCorner
      highlighted
      published={currentView !== 'unpublished'}
    />}

    {!loadingArticles && viewCategories
    .sort((a,b) => {
      if(sortAscending) {
        return (b === 'Highlighted') - (a === 'Highlighted') || a.localeCompare(b)
      }
      return (b === 'Highlighted') - (a === 'Highlighted') || b.localeCompare(a)
    })
    .map(category => {
      if (!articlesMap[currentView]?.[category]) return undefined
      const {articles, loading, loadingMore, totalAvailable, nextToken} = articlesMap[currentView]?.[category]
      if(!categoryFilterApplied && !articles?.length) return undefined
      return <Fragment key={`frag_${category}`}>
        {category !== 'Highlighted' && <Grid item xs={12} key={`${category}_heading`}>
          <Heading title={category} />
        </Grid>}
        <Grid item xs={12} key={`${category}_item`}>
          {category === 'Highlighted' && <MediumArticleList
            editable={canEdit}
            articles={articles || []}
            layout='horizontal'
            ouCorner
            ouCornerCategory={category === 'Highlighted' ? undefined : category}
            highlighted={category === 'Highlighted'}
            published={currentView !== 'unpublished'}
            loading={loading}
            loadingMore={loadingMore}
          />}

          {category !== 'Highlighted' && <ArticleCategory
            editable={canEdit}
            highlighted={category === 'Highlighted'}
            ouCornerCategory={category === 'Highlighted' ? undefined : category}
            articles={articles || []}
            loading={loading}
            loadingMore={loadingMore}
            totalArticlesAvailable={totalAvailable}
            moreAvailable={totalAvailable > articles?.length || nextToken !== undefined}
            loadMoreArticles={() => loadArticlesForCategory(false, category, 2)}
            window={tilesPerRow}
            loopArticles={false}
          />}
        </Grid>
      </Fragment>
    })}

  </Grid>

  const tabViews = [
    {
      key: TabbedViews.PUBLISHED,
      label: 'Published',
      el: OUCornerArticles
    },
    {
      key: TabbedViews.UNPUBLISHED,
      label: 'Unpublished',
      el: OUCornerArticles
    },
  ]

  const startLoading = () => {
    setIsLoading(true)
  }

  const stopLoading = () => {
    setIsLoading(false)
  }

  useEffect(() => {
    EventBus.on(Event.START_PAGE_LOADING, startLoading)
    EventBus.on(Event.STOP_PAGE_LOADING, stopLoading)
    return () => {
      EventBus.removeListener(Event.START_PAGE_LOADING, startLoading)
      EventBus.removeListener(Event.STOP_PAGE_LOADING, stopLoading)
    }
  }, [])

  const loadArticles = useCallback(async (offset = 0, limit = 4) => {
    if (offset === 0) setLoadingArticles(true)
      
    await Promise.all(categories.map(async category => {
      await loadArticlesForCategory(true, category, limit)
    }))
    setLoadingArticles(false)
  }, [categories, loadArticlesForCategory])

  useEffect(() => {
    (async () => {
      const siteSettings = await getSiteSettings()
      const _categories = siteSettings?.articles?.categories || []
      setCategories(['Highlighted', ..._categories])
      setViewCategories(['Highlighted', ..._categories])
    })()
  }, [])

  useEffect(() => {
    if (categories.length) {
      loadArticles(0, tilesPerRow)
    }
  }, [categories, currentView, filter, tilesPerRow, loadArticles])

  useEffect(() => {
    if(props.resetPage) {
      EventBus.on(Event.REFRESH_PAGE, props.resetPage)
      return () => {
        EventBus.removeListener(Event.REFRESH_PAGE, props.resetPage)
      }
    }
  }, [props.resetPage])

  const onTabChange = (tabIndex) => {
    const viewKey = tabViews[tabIndex].key
    if (viewKey === TabbedViews.UNPUBLISHED) {
      setSearchParams()
    }
    setCurrentView(viewKey)
  }

  const addArticle = () => {
    EventBus.emit(CommunityEventNames.OPEN_ADD_EDIT_ARITCLE_DIALOG, {
      mode: 'add',
      article: {
        ouCorner: true,
      },
      visibility: {
        ouCorner: true,
      }
    })
  }


  return (
    <Page {...props} breadcrumb={<div><span>{props.siteConfig?.label ?? ''} OU Corner</span></div>} isLoading={isLoading}
      navClassName='article-nav'
      commandBar={<ArticlesCommandBar
        addRecordLabel='Create an Article'
        showAdd={canEdit}
        addRecord={addArticle}
        addRecordButtonVariant="contained"
      />}
    >

      <Paper
        component="form"
        sx={{ backgroundColor: 'transparent', border: 'none', boxShadow: 'none', display: 'flex', flexDirection: 'column', flexWrap: 'wrap', margin: '0 auto 1em auto' }}
      >
        {canEdit && <AddEditArticleDialog />}
        <ShareArticleDialog />
        <SharePreviewDialog />
        {canEdit && <TabPanel panelId='resources' key='resources' tabs={tabViews}
          defaultTab={Math.max(tabViews.findIndex(v => v.key === currentView), 0)}
          onTabChange={(idx) => onTabChange(idx)}
          tabStyle={{ textTransform: 'none', minHeight: 'unset' }}
        />}
        {!canEdit && tabViews[0].el}
      </Paper>
    </Page>
  )
}

// It's easier to just completely reset the component and blow away cache keys here to ensure the cache context always gets updated
export default function OUCornerPage(props) {
  const { pathname } = useLocation()
  
  const siteKey = useMemo(() => {
    return pathname.split('/').filter(Boolean)[0] ?? null
  }, [pathname])

  const [config, setConfig] = useState(null)

  const [instanceKey, setInstanceKey] = React.useState(0);
  // call this anywhere to reset the component
  const resetPage = useCallback(() => {
    Cache.removeItem('site-settings')
    Cache.removeItemsStartingWith('pinned-articles')
    Cache.removeItemsStartingWith('news-totalLoaded')
    Cache.removeItemsStartingWith('get-articles')
    Cache.removeItemsStartingWith('list-articles')
    setInstanceKey((k) => k + 1);
  }, []);

  useEffect(() => {
    if (!siteKey) return;

    resetPage()
    const _config = getSiteConfig(siteKey)
    setConfig(_config)
  }, [siteKey, resetPage])

  // render an inner "real" version of the component with a key
  return (
    <InnerOUCornerPage
      key={instanceKey}
      siteConfig={config}
      {...props}
      resetPage={resetPage}
    />
  );
}